import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

const RoyalRadio = ({id, checked, ariaLabel}) => {
  if (!id) {
    throw new Error(
      'Inputs need ids that  are the same for attribute as their labels https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/radio',
    );
  }

  return (
    <input
      className={`RoyalRadio__input ${checked ? 'RoyalRadio__input--checked' : ''}`}
      type="radio"
      id={id}
      checked={checked}
      readOnly
      aria-label={ariaLabel}
    />
  );
};

RoyalRadio.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  checked: PropTypes.bool,
  ariaLabel: PropTypes.string,
};

export default RoyalRadio;
